
/* System defined core library */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/* User defined library/components */
import { SchedulingComponent } from './scheduling/scheduling.component'
import { HomeComponent } from './shared/components/home/home.component'
import { AuthGuard } from './shared/services/activation-guard.service'
const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            { path: '', component: HomeComponent, data: { title: 'Homepage' } },    
            { path: 'home', component: HomeComponent, data: { title: 'Homepage' } }, 
            { path: 'scheduling', component: SchedulingComponent },
        ]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
